import script from "./WaterCollectionPage.vue?vue&type=script&setup=true&lang=js"
export * from "./WaterCollectionPage.vue?vue&type=script&setup=true&lang=js"

import "./WaterCollectionPage.vue?vue&type=style&index=0&id=059d04f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-059d04f2"]])

export default __exports__